import { byWindowAction, debounce, getBreakpointMinWidth } from '@html/_common/utils';

/** *********************************************
 *
 * CAROUSEL
 *
 * example usage:
 *
 *  const testCarousel = new Carousel('.js-example-carousel-selector');
 *  testCarousel.onScrollAnalytics(() => {
 *    // ga
 *  });
 *  testCarousel.onRightClickAnalytics(() => {
 *    // ga
 *  });
 *  testCarousel.onLeftClickAnalytics(() => {
 *    // ga
 *  });
 *  testCarousel.initiate();
 *
 ********************************************* */

export default class AOCarouselLinks {
  constructor(carouselSelector) {
    this.$carousel = $(carouselSelector);

    this.$itemsContainer = this.$carousel.find('.js-ao-common-carousel__items-container');
    this.$items = this.$itemsContainer.children();

    // analytics callbacks
    this.onScrollAnalyticsCallback = null;
    this.onRightClickAnalyticsCallback = null;
    this.onLeftClickAnalyticsCallback = null;

    this.$arrowLeft = this.$carousel.find('.js-ao-common-carousel__arrow--left');
    this.$arrowRight = this.$carousel.find('.js-ao-common-carousel__arrow--right');

    this.$backgroundArrowLeft = this.$carousel.find('.js-ao-common-carousel__arrow-background--left');
    this.$backgroundArrowRight = this.$carousel.find('.js-ao-common-carousel__arrow-background--right');

    this.numberOfItems = this.$items.length;
    this.$firstItem = this.$items.first();

    this.index = 0;

    this.isMinBreakpoint = ($(window).width() <= getBreakpointMinWidth('m1'));
    this.itemWidth = this.isMinBreakpoint ? 198 : 267;

    this.calcItemsShown();
  }
  /** ********************************************
   *
   * PUBLIC
   *
   ********************************************* */

  initiate() {
    this.attachEventHandlers();
    this.scrollToCurrentIndex();
    this.checkArrowVisibility();
  }

  onScrollAnalytics(callback) {
    this.onScrollAnalyticsCallback = callback;
  }

  onRightClickAnalytics(callback) {
    this.onRightClickAnalyticsCallback = callback;
  }

  onLeftClickAnalytics(callback) {
    this.onLeftClickAnalyticsCallback = callback;
  }

  /** ********************************************
   *
   * PRIVATE
   *
   ********************************************* */

  attachEventHandlers() {
    this.$arrowLeft.click(() => {
      this.onClickArrow('left');
    });

    this.$arrowRight.click(() => {
      this.onClickArrow('right');
    });

    byWindowAction(['resize'], debounce(this.onResize.bind(this), 300));
  }

  onClickArrow(direction) {
    this.calcItemsShown();
    this.calculateNewIndex(direction);
    this.onArrowClickAnalytics(direction);
    this.scrollToCurrentIndex();
    this.checkArrowVisibility();
  }

  onResize() {
    this.itemWidth = this.isMinBreakpoint ? 198 : 267;
    this.isMinBreakpoint = ($(window).width() <= getBreakpointMinWidth('m1'));
    this.index = 0;
    this.scrollToCurrentIndex(this.index);
    this.calcItemsShown();
    this.checkArrowVisibility();
  }

  calculateNewIndex(direction) {
    if (direction === 'right') this.index += 1;
    if (direction === 'left') this.index -= 1;
  }

  scrollToCurrentIndex() {
    this.$items.css('margin-left', 0);

    if (this.isMinBreakpoint) this.$items.slice(0, this.index * 2).css('margin-left', -(this.index * this.itemWidth));
    else this.$firstItem.css('margin-left', -(this.index * this.itemWidth));
  }

  checkArrowVisibility() {
    const showLeftArrow = this.index !== 0;
    const showRightArrow = this.isMinBreakpoint
      ? (this.itemsShown + (this.index * 2)) < this.numberOfItems
      : (this.itemsShown + this.index) < this.numberOfItems;

    this.$arrowLeft.toggleClass('hid', !showLeftArrow);
    this.$arrowRight.toggleClass('hid', !showRightArrow);

    this.$backgroundArrowLeft.toggleClass('hid', !showLeftArrow);
    this.$backgroundArrowRight.toggleClass('hid', !showRightArrow);
  }

  onScroll() {
    this.onScrollAnalyticsCallback();
  }

  onArrowClickAnalytics(direction) {
    if (direction === 'right' && this.onRightClickAnalyticsCallback) {
      this.onRightClickAnalyticsCallback();
    }
    if (direction === 'left' && this.onLeftClickAnalyticsCallback) {
      this.onLeftClickAnalyticsCallback();
    }
  }

  calcItemsShown() {
    const itemsShown = this.isMinBreakpoint
      ? ((this.$itemsContainer.width() / this.itemWidth) * 2)
      : (this.$itemsContainer.width() / this.itemWidth);

    this.itemsShown = itemsShown >= this.numberOfItems
      ? this.numberOfItems
      : itemsShown;
  }
}
